import { connect } from 'react-redux'
import DriveDetails from 'modules/DriveDetails/index'
import selector from 'modules/DriveDetails/selectors'
import { getDriveDetails ,DriveDateSelection, ResheduleDriveDate} from 'modules/DriveDetails/actions'
import {getSingleRoleDetails} from 'modules/ViewRole/actions'
import selector1 from 'modules/ViewRole/selectors'
import { getStudentData} from 'modules/Resume/actions'
import selectorOB from 'modules/Onboarding/selectors'
import authSelectors from 'modules/Auth/selectors'

const mapStateToProps = state => ({
    
    drivesDetail: selector.getDriveDetail(state),
    viewRoleDetails: selector1.getSingleRoleDetail(state),
    studentDetails: selectorOB.getStudentResumeData(state),
    permissions: authSelectors.getUserPermissions(state),
})

const mapDispatchToProps = {
    getDriveDetails,
    getSingleRoleDetails,
    getStudentData,
    DriveDateSelection,
    ResheduleDriveDate
}

export default connect(mapStateToProps, mapDispatchToProps)(DriveDetails)
